import React, { useState } from "react";
import ReactDatatable from "@mkikets/react-datatable";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useGetRewardTransactionsQuery } from "../../../redux/rewardTransactionApi";

function RewardTransaction() {
    const { t } = useTranslation();

    const [params, setParams] = useState({
        page: 1,
        limit: 10,
        search: ""
    });
    const [searchTerm, setSearchTerm] = useState("");

    const { data: apiResponse } = useGetRewardTransactionsQuery(params);
    const records = apiResponse?.data?.records || [];
    const totalRecords = apiResponse?.data?.total_count || 0;

    const columns = [
        {
            key: "srno.",
            text: t('sr_no'),
            className: "sr_no.",
            align: "left",
            sortable: true,
            cell: (row, index) => (params.page - 1) * params.limit + index + 1,
        },
        {
            key: "user_email",
            text: t('email'),
            className: "email",
            align: "left",
            sortable: true,
            //cell: (record) => record.user?.email || record.user_id || "-",
        },
        {
            key: "user_mobile",
            text: t('mobile'),
            className: "mobile",
            align: "left",
            sortable: true,
            //cell: (record) => record.user?.email || record.user_id || "-",
        },
        {
            key: "user_name",
            text: t('name'),
            className: "name",
            align: "left",
            sortable: true,
            cell: (record) => record.user_name || "-",
        },
        {
            key: "coin_amount",
            text: t('amount'),
            className: "amount",
            align: "left",
            sortable: true,
        },
        {
            key: "reward_type",
            text: t('type'),
            className: "type",
            align: "left",
            sortable: true,
        },
        {
            key: "coin_symbol",
            text: t('coin_name'),
            className: "coin_name",
            align: "left",
            sortable: true,
            cell: (record) => {
                return <><img style={{ width: "20px", height: "20px" }} className="img-fluid" src={record.coin_logo_url} alt="" />{"  "}{record.coin_symbol} {record.network_symbol}</>;
            },
        },
        {
            key: "from_user_email",
            text: t('from_user'),
            className: "coin_name",
            align: "left",
            sortable: true,
        },
        {
            key: "created_at",
            text: t('date'),
            className: "date",
            align: "left",
            sortable: true,
            cell: (record) => {
                return <>{moment(record.created_at).format("DD/MM/YYYY HH:mm:ss")}</>;
            },
        },
    ];

    const config = {
        page_size: 10,
        length_menu: [10, 20, 50],
        filename: "Reward Transactions",
        no_data_text: t('no_record_found'),
        language: {
            filter: t('search_in_records'),
            pagination: {
                first: t('first'),
                previous: t('previous'),
                next: t('next'),
                last: t('last'),
            },
        },
        show_length_menu: true,
        show_filter: false,
        show_pagination: true,
        show_info: true,
    };

    const handleTableChange = (newParams) => {
        setParams({
            ...params,
            page: newParams.page_number,
            limit: newParams.page_size,
        });
    }

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value)
    }

    const handleSearchSubmit = () => {
        setParams({
            ...params,
            page: 1,
            search: searchTerm
        });
    }

    return (
        <section className="section dashboard">
            <div className="pagetitle d-flex align-items-center justify-content-between mb-4">
                <h1>{t('reward_transactions')}</h1>
                <div className="col-md-4 d-flex">
                    <input
                        type="text"
                        className="form-control me-2"
                        placeholder={t('reward_search_placeholder')}
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    <button className="btn btn-primary" onClick={handleSearchSubmit}>{t('search')}</button>
                </div>
            </div>

            <div className="card">
                <div className="card-body pt-4">
                    <ReactDatatable
                        key={`datatable-${params.search}`}
                        config={config}
                        records={records}
                        columns={columns}
                        dynamic={true}
                        total_record={totalRecords}
                        onChange={handleTableChange}
                    />
                </div>
            </div>
        </section>
    );
}

export default RewardTransaction;
